/**
 * Inline vector marks for the navigation menu.
 *
 * These render the same v2 thin-stroke artwork as
 * public/icons/logo-architect.svg / logo-polymath.svg, but inlined with
 * stroke="currentColor" so they behave exactly like the lucide icons:
 * no network fetch (a failed fetch of a CSS mask image renders the icon
 * invisible on flaky connections) and native text-color inheritance in
 * every theme, color mode, and selected state.
 *
 * If the brand marks change, update both the public SVGs (used by other
 * surfaces) and these paths.
 */

type IconProps = React.SVGProps<SVGSVGElement>;

export function ArchitectMark(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      role="img"
      aria-label="ORION"
      {...props}
    >
      <defs>
        <clipPath id="architect-mark-ring">
          <circle cx="50" cy="50" r="40" />
        </clipPath>
      </defs>
      <g fill="none" stroke="currentColor">
        <path d="M 44.45 87.59 A 38 38 0 1 1 55.55 87.59" strokeWidth="4" />
        <g clipPath="url(#architect-mark-ring)">
          <path d="M 25.17 78.76 L 50 17.6 L 74.83 78.76" strokeWidth="4.2" />
          <path d="M 32 62.3 L 52.5 62.3" strokeWidth="4" />
        </g>
      </g>
    </svg>
  );
}

export function PolymathMark(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      role="img"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <clipPath id="polymath-mark-ring">
          <circle cx="50" cy="50" r="40" />
        </clipPath>
      </defs>
      <g fill="none" stroke="currentColor">
        <path d="M 57.77 87.2 A 38 38 0 1 0 41.5 87.03" strokeWidth="4" />
        <g clipPath="url(#polymath-mark-ring)">
          <path d="M 40.15 23 L 40.15 89" strokeWidth="4.2" />
          <path
            d="M 38.05 23 L 56.5 23 A 16 19.7 0 0 1 56.5 62.4 L 38.05 62.4"
            strokeWidth="4.2"
          />
        </g>
      </g>
    </svg>
  );
}
